import { createFeature, createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { GeraetDto } from '../../api/models';
import { GeraeteActions } from './geraete.actions';

export const geraeteFeatureKey = 'geraete';

export type State = {
  geraete: GeraetDto[];
  loading: boolean;
};

export const initialState: State = {
  geraete: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(GeraeteActions.loadGeraete, (state) => {
    return produce(state, (draft) => {
      draft.loading = false;
    });
  }),
  on(GeraeteActions.loadGeraeteSuccess, (state, { geraete }) => {
    return produce(state, (draft) => {
      draft.geraete = geraete;
      draft.loading = false;
    });
  }),
  on(GeraeteActions.loadGeraeteFailure, (state) => {
    return produce(state, (draft) => {
      draft.loading = false;
    });
  }),
);

export const geraeteFeature = createFeature({
  name: geraeteFeatureKey,
  reducer,
});
